var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47.22,35.85c0-0.78-0.71-1.38-1.48-1.24c-0.62,0.11-1.22,0.33-1.78,0.65l-3.25,1.9 c-0.92,0.54-2.06,0.54-2.98,0l-3.25-1.9c-1.71-1-3.84-1-5.56,0l-3.25,1.9c-0.92,0.54-2.06,0.54-2.98,0l-3.25-1.9 c-1.71-1-3.84-1-5.56,0l-3.25,1.9c-0.92,0.54-2.06,0.54-2.98,0l-3.25-1.9c-0.68-0.4-1.43-0.64-2.18-0.72 c-0.73-0.08-1.35,0.53-1.35,1.26v0.03c0,0.63,0.47,1.17,1.1,1.25c0.4,0.05,0.79,0.17,1.15,0.38l3.25,1.9c1.72,1,3.84,1,5.56,0 l3.25-1.9c0.92-0.54,2.06-0.54,2.98,0l3.25,1.9c1.72,1,3.84,1,5.56,0l3.25-1.9c0.92-0.54,2.06-0.54,2.98,0l3.25,1.9 c1.72,1,3.84,1,5.56,0l3.25-1.9c0.29-0.17,0.61-0.29,0.93-0.35c0.6-0.11,1.04-0.63,1.04-1.24V35.85z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.66,31.95c0-0.46,0.07-0.9,0.2-1.31c0.12-0.37-0.06-0.78-0.4-0.98l-0.01,0c-1.71-1-3.84-1-5.56,0 l-3.25,1.9c-0.92,0.54-2.06,0.54-2.98,0l-3.25-1.9c-0.68-0.4-1.43-0.64-2.18-0.72c-0.73-0.08-1.35,0.53-1.35,1.26v0.03 c0,0.63,0.47,1.17,1.1,1.25c0.4,0.05,0.79,0.17,1.15,0.38l3.25,1.9c1.72,1,3.84,1,5.56,0l3.24-1.9c0.92-0.54,2.06-0.54,2.98,0 l1.57,0.92C19.69,32.5,19.66,32.23,19.66,31.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.74,29c-0.62,0.11-1.22,0.33-1.78,0.65l-3.25,1.9c-0.92,0.54-2.06,0.54-2.98,0l-3.25-1.9 c-1.71-1-3.84-1-5.56,0l-0.24,0.14c-0.35,0.2-0.49,0.61-0.39,1c0.1,0.37,0.16,0.75,0.16,1.15c0,0.35-0.04,0.68-0.12,1.01l1.88-1.1 c0.92-0.54,2.06-0.54,2.98,0l3.25,1.9c1.72,1,3.84,1,5.56,0l3.25-1.9c0.29-0.17,0.61-0.29,0.93-0.35c0.6-0.11,1.04-0.63,1.04-1.24 v-0.03C47.22,29.46,46.51,28.86,45.74,29z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.42,14.95c0.53,0,0.96-0.43,0.96-0.96v-0.02c0-0.53-0.43-0.96-0.96-0.96h-1.48v-2.12 c0-1.03-0.83-1.86-1.86-1.86h-0.04c-1.03,0-1.86,0.83-1.86,1.86v18.3c-0.83,0.59-1.38,1.56-1.38,2.66c0,1.8,1.46,3.26,3.26,3.26 c1.8,0,3.26-1.46,3.26-3.26c0-1.1-0.55-2.07-1.38-2.66v-5.73h1.48c0.53,0,0.96-0.43,0.96-0.96v-0.02c0-0.53-0.43-0.96-0.96-0.96 h-1.48v-2.3h1.48c0.53,0,0.96-0.43,0.96-0.96v-0.02c0-0.53-0.43-0.96-0.96-0.96h-1.48v-2.3H27.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/52.a0f9478262de594ce1999a141d045214.svg";
export { ForwardRef as ReactComponent };